module.exports = __webpack_public_path__ + "static/media/pop-the-virus.e094f4fb.jpg";